import createStyleSheet from 'src/utilities/createStyleSheet'

export const konvaImageDrawToolbarStyles = createStyleSheet({
  toolbar: {
    display: 'flex',
    justifyContent: 'center',
    background: '#F2F4F7',
    borderRadius: '50px',
    alignItems: 'center',
    minWidth: '261px',
    maxWidth: '261px',
  },
})
